import { Record as record } from 'immutable';
import _ from 'lodash';
import joi from 'joi';

import { construct } from '../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../helpers/Records';
import ValidationMixin from '../ValidationMixin';
import validation from '../../validation';

const schema = {
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    townCity: '',
    postcode: '',
    country: 'GBR',
};

class ADRSubscribeForm extends record(getDefaults(schema)) {

    static fromJSON (json = {}) {
        return construct(ADRSubscribeForm, _.defaults(json, getDefaults(schema)), getResolvers(schema));
    }

    getSchema () {
        return {
            addressLine1: validation.addressLine().required(),
            addressLine2: validation.textMaxLength(),
            addressLine3: validation.textMaxLength(),
            townCity: validation.townCity(),
            postcode: joi.any().when('country', {
                is: schema.country,
                then: validation.postcode(),
                otherwise: validation.optional()
            }),
            country: validation.country(),
        };
    }
}


Object.assign(ADRSubscribeForm.prototype, ValidationMixin);


export default ADRSubscribeForm;
